import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import CodeProduitLocalComponent from '../../../components/Mouvement/Panel/CodeProduitLocalComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import LignePanel from './LignePanel';

class CodeProduitLocalPanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.CODE_PRODUIT_LOCAL;
		this.icon = { name: 'compass outline' };
	}

	getLibelle = () => 'Code produit local';

	isEmpty = (data: Mouvement) =>
		!data?.lignes?.find((ligne) => ligne?.identifiantCodprodloc);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<CodeProduitLocalComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default CodeProduitLocalPanel;
